import { createContext } from 'react';
import { UserType } from '../types/user.type';
import { Callback } from 'amplitude-js';
import { TrackingEvent } from '../types/tracking-events.enum';
import { EventProperties } from '../types/tracking-event-properties.type';
import _ from 'lodash';

type TrackingContextType = {
    sendEvent: (
        event: TrackingEvent,
        eventProperties?: EventProperties,
        callback?: Callback,
    ) => void;
    debouncedSendEvent: _.DebouncedFunc<(event: TrackingEvent) => void>;
    setUserProperties: (user?: Partial<UserType>) => void;
    setUserId: (userId: string | undefined | null) => void;
    clearUserProperties: () => void;
};
export const TrackingContext = createContext<TrackingContextType>({
    sendEvent: (
        event: TrackingEvent,
        eventProperties?: EventProperties,
        callback?: Callback,
    ): void => {},
    debouncedSendEvent: _.debounce((event: TrackingEvent) => {}, 1000),
    setUserProperties: (user?: Partial<UserType>): void => {},
    setUserId: (userId: string | undefined | null): void => {},
    clearUserProperties: (): void => {},
});
